<kfm-card [cardTitle]="reportLabel" [cardIcon]="cardIcon()">
  <hs-form-field>
    <hs-form-label>{{ reportLabel }}</hs-form-label>
    <textarea
      hsInput
      [placeholder]="reportLabel"
      class="min-h-25"
      [disabled]="!isEditable()"
      [value]="longDesc()"
      (change)="onLongDescChanged($any($event.target).value)"
    ></textarea>
  </hs-form-field>

  <div class="flex flex-row gap-3">
    <hs-form-field class="w-1/3">
      <hs-form-label>{{ dateLabel }}</hs-form-label>
      <hs-date-picker
        [value]="signDate()"
        [disabled]="!isEditable()"
        (change)="onDateChanged($any($event.target).value)"
      ></hs-date-picker>
    </hs-form-field>

    <hs-form-field class="w-2/3">
      <hs-form-label>{{ locationLabel }}</hs-form-label>
      <input
        hsInput
        [placeholder]="locationLabel"
        [value]="location()"
        [disabled]="!isEditable()"
        [value]="location()"
        (change)="onLocationChanged($event.target.value)"
      />
    </hs-form-field>
  </div>
</kfm-card>
